import { TextArea as FabricTextArea } from '@bamboohr/fabric';
import classNames from 'classnames';
import { camelCase, capitalize } from 'lodash';

export const TextArea = (props) => {
	const {
		errorState,
		label,
		name,
		data,
		placeholder,
		typeProps = {},
		validationRegistration,
	} = props;

	if (!data) {
		return null;
	}

	return (
		<div className={ `fab-FormColumn CandidateField CandidateField--${ name }` }>
			<label
				className={ `fab-Label ${ data.isRequired ? 'fab-Label--required' : '' } ${ errorState ? 'fab-Label--error' : '' }` }
				htmlFor={ name }
			>
				{ label }
			</label>
			<div
				className={ classNames(`fab-InputWrapper CandidateField__inputWrapper CandidateField__inputWrapper--${ name }`, {
					[`CandidateField__inputWrapper--cq${ capitalize(camelCase(typeProps.cqType)) }`]: typeProps.cqType,
				}) }
			>
				<FabricTextArea
					disabled={ Boolean(data.isDisabled) }
					id={ name }
					inputProps={{defaultValue: data.value}}
					name={ name }
					placeholder={ placeholder }
					ref={ validationRegistration }
					required={ data.isRequired }
					status={ errorState ? 'error' : undefined }
				/>
			</div>
		</div>
	);
};
